"use client";

import Link from "next/link";
import Logo from "@/assets/logo-lifestyle.svg";
import Section from "@/components/ui/Section";
import { Button } from "./ui/button";

export default function Footer() {
  const year = new Date().getFullYear();
  const copyright = `© ${year} Maura. All rights reserved.`;
  return (
    <Section
      as="footer"
      wrapperClassName="bg-background-dark text-white !py-8"
      className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4"
    >
      <Logo className="h-12 w-auto text-white" />
      <div>
        {/*<Button variant="link-white" asChild size="xs">
          <Link href="/legal/terms-of-service">Terms of Service</Link>
        </Button>
        <span className="mx-2">|</span>*/}

        <Button variant="link-white" asChild size="xs">
          <Link href="/contact-us">Contact Us</Link>
        </Button>
        <span className="mx-2">|</span>
        <Button variant="link-white" asChild size="xs">
          <Link href="/faqs">FAQs</Link>
        </Button>
        <span className="mx-2">|</span>
        <Button variant="link-white" asChild size="xs">
          <Link href="/legal/privacy-policy-web">Privacy Policy</Link>
        </Button>
        <span className="mx-2">|</span>
        <small>{copyright}</small>
      </div>
    </Section>
  );
}
